import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useContentItems } from '../use-content-items.query';
import { useAtom } from 'jotai';
import { contentItemInEditModeState } from '../feed.state';
import { useToggleContentItemSidebar } from './use-toggle-content-item-sidebar';

const CONTENT_ITEM_SIDEBAR_SEARCH_PARAM = 'contentItemId';

export const useContentItemSearchParams = () => {
  const [isInitialized, setIsInitialized] = useState(false);

  const { data, isFetching } = useContentItems();
  const [searchParams] = useSearchParams();

  const [contentItemInUpdate, setContentItemInUpdate] = useAtom(
    contentItemInEditModeState,
  );

  const { navigateToFeedTab, navigateToContentItemSidebar } =
    useToggleContentItemSidebar();

  const isOpened = searchParams.has(CONTENT_ITEM_SIDEBAR_SEARCH_PARAM);
  const contentItemIdParam = searchParams.get(
    CONTENT_ITEM_SIDEBAR_SEARCH_PARAM,
  );

  useEffect(() => {
    if (data === undefined || isFetching) return;

    if (!contentItemIdParam) {
      setContentItemInUpdate(null);
      setIsInitialized(true);
      return;
    }

    const item = data.find(i => i.id === contentItemIdParam);
    setContentItemInUpdate(item ?? null);
    setIsInitialized(true);

    if (!item) {
      navigateToContentItemSidebar();
    }
  }, [
    isFetching,
    data,
    contentItemIdParam,
    setContentItemInUpdate,
    navigateToContentItemSidebar,
  ]);

  const closeAndResetSidebar = () => {
    setContentItemInUpdate(null);
    navigateToFeedTab();
  };

  return {
    closeAndResetSidebar,
    isOpened,
    isEditMode: contentItemInUpdate !== null,
    isInitialized,
  };
};
